
import React from "react";
import { Form, Select, Modal, Button } from "antd";


const UserFilter = ({
    userRole,
    setUserRole,
    onFilter,
    onClearFilter,
    open,
    setFilterOpen,
}) => {

    return (
        <Modal
            autoAdjustOverflow={false}
            title="Filter By"
            trigger="click"
            open={open}
            onOk={onFilter}
            onCancel={() => setFilterOpen(false)}
            footer={null}
        >
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginBottom: '10px' }}>
                <Select
                    id="user-filter-role-select"
                    size={"large"}
                    value={userRole}
                    placeholder="Filter by User Role"
                    onChange={setUserRole}
                >
                    <Select.Option value={null}>All</Select.Option>
                    <Select.Option value={"it system admin"}>
                        IT System Admin
                    </Select.Option>
                    <Select.Option value={"ops admin"}>
                        Ops Admin
                    </Select.Option>
                    <Select.Option value={"developer"}>
                        Developer
                    </Select.Option>
                </Select>
            </div>
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                <Button id="user-filter-clear-btn" type="secondary" size="large" onClick={onClearFilter}>Clear</Button>
            </div>  
        </Modal>
    );
};

export default UserFilter;
